export default __webpack_public_path__ + "static/media/qr_demo.fd711370.png";